var _excluded = ["label", "isInvalid", "tooltipProps", "description", "isDisabled", "isReadOnly", "isViewMode", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Group } from '../../../../containers';
import { forwardRef } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { _IconIndicator, Box } from '../../../internal';
/**
 * @private
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private
 */
export var _Label = forwardRef((_ref, ref) => {
  var {
    label,
    isInvalid,
    tooltipProps,
    description,
    isDisabled,
    isReadOnly,
    isViewMode,
    id
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('_Label', {
    isInvalid
  });
  var sharedAttributes = {
    'data-disabled': isDisabled || null,
    'aria-invalid': isInvalid,
    'data-readonly': isReadOnly || null,
    'data-view-mode': isViewMode || null
  };
  return /*#__PURE__*/_jsxs(Group, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    "data-component": "_Label"
  }, sharedAttributes), {}, {
    "aria-disabled": isDisabled,
    alignItems: "center"
  }, props), {}, {
    spacing: "xxs",
    children: [/*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
      as: "label" // ts-ignore is used due to `type` issues with `<Box/>`.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ,
      htmlFor: id,
      __css: styles['label']
    }, sharedAttributes), {}, {
      children: [label, description && /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
        __css: styles['description'],
        as: "span"
      }, sharedAttributes), {}, {
        children: description
      }))]
    })), tooltipProps && /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      __css: styles['iconIndicator']
    }, sharedAttributes), {}, {
      children: /*#__PURE__*/_jsx(_IconIndicator, {
        tooltip: tooltipProps,
        "data-testid": "label-tooltip-trigger"
      })
    }))]
  }));
});
_Label.displayName = '_Label';
//# sourceMappingURL=_Label.js.map